import { useEffect, useState, useRef } from "react";
import api from "@/lib/api";
import { useNavigate, useLocation } from "react-router-dom";
import { MessagesSquare } from "lucide-react";
import { toast } from "sonner";

export default function ChatBell() {
  const [unread, setUnread] = useState(0);
  const [latest, setLatest] = useState(null);
  const lastCount = useRef(0);
  const navigate = useNavigate();
  const location = useLocation();

  const load = async () => {
    try {
      const { data } = await api.get("/chat/unread-count");
      if (data.unread > lastCount.current && data.latest && location.pathname !== "/chat") {
        toast.message(`💬 ${data.latest.author_name}`, {
          description: data.latest.text || "📎 sent an attachment",
        });
      }
      lastCount.current = data.unread;
      setUnread(data.unread);
      setLatest(data.latest);
    } catch {}
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
    // eslint-disable-next-line
  }, [location.pathname]);

  // when user is on /chat, mark read continuously
  useEffect(() => {
    if (location.pathname === "/chat") {
      setUnread(0);
    }
  }, [location.pathname]);

  return (
    <button
      onClick={() => navigate("/chat")}
      className="relative p-2 hover:bg-zinc-100 border border-zinc-200"
      data-testid="chat-bell"
      title={latest ? `${latest.author_name}: ${latest.text || "attachment"}` : "Team chat"}
      aria-label="Team chat"
    >
      <MessagesSquare size={16} className="text-emerald-700" />
      {unread > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 bg-emerald-600 text-white text-[10px] font-bold flex items-center justify-center rounded-full">
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </button>
  );
}
